import { render, staticRenderFns } from "./ContractorFullInformationLink.vue?vue&type=template&id=1c58b45e"
import script from "./ContractorFullInformationLink.vue?vue&type=script&lang=ts"
export * from "./ContractorFullInformationLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c58b45e')) {
      api.createRecord('1c58b45e', component.options)
    } else {
      api.reload('1c58b45e', component.options)
    }
    module.hot.accept("./ContractorFullInformationLink.vue?vue&type=template&id=1c58b45e", function () {
      api.rerender('1c58b45e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/ContractorFullInformationLink.vue"
export default component.exports